module.exports = __webpack_public_path__ + "img/822005102.6d9f3065.png";